import React, { Component } from "react";
import styled from "styled-components";

const Container = styled.div`
  box-shadow: 0 3px 7px -3px rgba(0, 0, 0, 0.3);
  position: relative;
  float: left;
  overflow: hidden;
  margin-top: 10px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 10px;
  max-width: ${props => `${props.containerWidth}px`};
  min-height: ${props => `${props.containerHeight}px`};
  width: 100%;
  color: #141414;
  text-align: left;
  line-height: 1.4em;
  font-size: 16px;
  background-color: ${props => props.primaryColor};
  &:* {
    box-sizing: border-box;
    transition: all 0.25s ease;
  }
`;
const Wrapper = styled.div`
  background-color: ${props => props.primaryColor};
  padding: 10px 25px 20px;
  position: relative;
  &:before {
    position: absolute;
    content: "";
    z-index: 2;
    bottom: 100%;
    left: 0;
    width: 100%;
    height: 80px;
    background-image: ${props => `linear-gradient(to bottom, transparent 0%, ${props.primaryColor} 100%)`};
  }
`;
const Image = styled.img`
  width: 100%;
  max-width: 100%;
  vertical-align: top;
`;
const Title = styled.h3`
  margin: 0 0 10px;
  font-weight: 300;
  line-height: 1.2em;
  font-family: "Oswald", Arial, sans-serif;
  text-align: center;
  padding-bottom: 10px;
`;
const Summary = styled.p`
  font-family: "Open Sans";
  font-size: 14px;
  text-align: justify;
  opacity: 0.9;
`;

export class NewsTransparentBottomBackgroundCard extends Component {
  render() {
    const { news, newsNumber, primaryColor, containerHeight, containerWidth } = this.props;
    if (news.length === 0) return null;

    return news.items.slice(0, newsNumber).map((article, i) => (
      <Container primaryColor={primaryColor} containerHeight={containerHeight} containerWidth={containerWidth} key={i}>
        <Image src={article.image.split("|")[0]} alt="" />
        <Wrapper primaryColor={primaryColor}>
          <Title>{article.title}</Title>
          <Summary> {article.description.split("...")[0]}... </Summary>
        </Wrapper>
      </Container>
    ));
  }
}



// WEBPACK FOOTER //
// ./src/components/News/NewsTransparentBottomBackgroundCard/index.js